import { render, staticRenderFns } from "./RegistrationApprovalPanel.vue?vue&type=template&id=18679251&scoped=true"
import script from "./RegistrationApprovalPanel.vue?vue&type=script&lang=js"
export * from "./RegistrationApprovalPanel.vue?vue&type=script&lang=js"
import style0 from "./RegistrationApprovalPanel.vue?vue&type=style&index=0&id=18679251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18679251",
  null
  
)

export default component.exports